import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
const echarts = require('echarts'); //echarts 5.0以上,用这种 方式引用,以前的方法,会出错或者是import * as echarts from 'echarts';
import elementui from 'element-ui'
import * as d3 from "d3"
import 'element-ui/lib/theme-chalk/index.css';
import 'normalize.css/normalize.css'; // a modern alternative to CSS resets
import './assets/css/global.css';
import './permission';
import './assets/icons'; //引入icons rem by adolf 210710
import './assets/fonts/iconfont.css';
//import Print from '@/lib/vue-print-nb/print.umd.min'  也可以这么引  
import Print from 'vue-print-nb'
import VueCropper from 'vue-cropper' //rem 引入cropper by adolf 210722
import VueBarcode from '@xkeshi/vue-barcode'; //导入条形码插件
import jquery from 'jquery';
Vue.component('barcode', VueBarcode); //声明条形码组件
Vue.use(Print); //注册print by adolf at 210622
Vue.use(elementui);
Vue.use(VueCropper);
Vue.prototype.$ = jquery;
Vue.prototype.$echarts = echarts //自定义属性rem by adolf at 210611
Vue.config.productionTip = false //关闭生产模式下提示
Vue.prototype.$d3 = d3
window.d3 = d3
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
Vue.prototype.openLoading = function(targetclass) { //主页面好用,dialog不好用 rem by adolf at 210625
    if (targetclass == '' || targetclass == null || targetclass == undefined) {
        targetclass = '.home';
    }
    const loading = this.$loading({ // 声明一个loading对象
        lock: true, // 是否锁屏
        text: '正在加载中...', // 加载动画的文字
        spinner: 'el-icon-loading', // 引入的loading图标
        background: 'rgba(0, 0, 0, 0.8)', // 背景颜色
        target: targetclass, // 需要遮罩的区域
        body: true,
        customClass: 'mask' // 遮罩层新增类名
    })
    setTimeout(function() { // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
        loading.close(); // 关闭遮罩层
    }, 5000)
    return loading;
}